// extracted by mini-css-extract-plugin
export default {"PageWithSidePanel":"PageWithSidePanel_PageWithSidePanel__PpNLu","open":"PageWithSidePanel_open__SsP8F"};